// extracted by mini-css-extract-plugin
export default {"accordion-header":"list_accordion-header__50+I8","accordion-icon":"list_accordion-icon__XbmZJ"};